import { render, staticRenderFns } from "./McPanelGroup.vue?vue&type=template&id=371f0aac&scoped=true&"
import script from "./McPanelGroup.vue?vue&type=script&lang=js&"
export * from "./McPanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./McPanelGroup.vue?vue&type=style&index=0&id=371f0aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f0aac",
  null
  
)

export default component.exports